import * as actions from '../../redux/actions';
import React, { useState, useEffect } from 'react';
import HeroSection from '../../common/HeroSection/HeroSection';
import ThemeElevenTitle from '../components/ThemeElevenTitle';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import getIcons from '../../functions/getIcons/getIcons';
import { useTranslation } from 'react-i18next';

const ThemeElevenFaq = ({ operator }) => {
    const { t, i18n } = useTranslation('common');
    const [accordionData, setAccordionData] = useState([]);

    useEffect(() => {
        setAccordionData([
            {
                id: 1,
                heading: t("PREGUNTAS.HEADING1"),
                content: operator && operator.terms ? operator.terms : t("PREGUNTAS.CONTENT1"),
                isOpen: false,
            },
            {
                id: 2,
                heading: t("PREGUNTAS.HEADING2"),
                content: operator && operator.privacy_policy ? operator.privacy_policy : t("PREGUNTAS.CONTENT2"),
                isOpen: false,
            },
            {
                id: 3,
                heading: t("PREGUNTAS.HEADING3"),
                content: operator && operator.privacy_policy ? operator.privacy_policy : t("PREGUNTAS.CONTENT3"),
                isOpen: false,
            },
            {
                id: 4,
                heading: t("PREGUNTAS.HEADING4"),
                content: operator && operator.privacy_policy ? operator.privacy_policy : t("PREGUNTAS.CONTENT4"),
                isOpen: false,
            },
            {
                id: 5,
                heading: t("PREGUNTAS.HEADING5"),
                content: operator && operator.privacy_policy ? operator.privacy_policy : t("PREGUNTAS.CONTENT5"),
                isOpen: false,
            },
            {
                id: 6,
                heading: t("PREGUNTAS.HEADING6"),
                content: operator && operator.privacy_policy ? operator.privacy_policy : t("PREGUNTAS.CONTENT6"),
                isOpen: false,
            },
            {
                id: 7,
                heading: t("PREGUNTAS.HEADING7"),
                content: operator && operator.privacy_policy ? operator.privacy_policy : t("PREGUNTAS.CONTENT7"),
                isOpen: false,
            },
            {
                id: 8,
                heading: t("PREGUNTAS.HEADING8"),
                content: operator && operator.privacy_policy ? operator.privacy_policy : t("PREGUNTAS.CONTENT8"),
                isOpen: false,
            },
            {
                id: 9,
                heading: t("PREGUNTAS.HEADING9"),
                content: operator && operator.privacy_policy ? operator.privacy_policy : t("PREGUNTAS.CONTENT9"),
                isOpen: false,
            },
            {
                id: 10,
                heading: t("PREGUNTAS.HEADING10"),
                content: operator && operator.privacy_policy ? operator.privacy_policy : t("PREGUNTAS.CONTENT10"),
                isOpen: false,
            },
        ]);
    }, [t, i18n.language, operator]);

	const toggleAccordion = id => {
		setAccordionData(prevAccordionData =>
			prevAccordionData.map(accordion => ({
				...accordion,
				isOpen: accordion.id === id ? !accordion.isOpen : false,
			})),
		);
	};
	return (
		<div className="themes-theme-eleven-faq">
			<div style={{ position: 'relative', marginTop: '-41px' }}>
				<HeroSection heroImage={getIcons('faqsBanner')} />
			</div>
			<ThemeElevenTitle operator={operator} smallHeading={t("PREGUNTAS.SMALL_HEADING")} boldHeading={t("PREGUNTAS.BOLD_HEADING")} />

			<div className="new-container-compact mb15 mt10 ">
				{accordionData.map((accordion, index) => (
					<div key={accordion.id} className="accord-block">
						<span onClick={() => toggleAccordion(accordion.id)} className="accordion-toggle">
							<div className="accord-heading">
								<p className="bold-text font13">{accordion.heading}</p>
							</div>

							<div className="accord-icon ">
								{accordion.isOpen ? (
									<span class="yellow-icon">
										<img alt="white-arrow" src={getIcons('accordOpen', operator)} />
									</span>
								) : (
									<img alt="white-arrow" src={getIcons('accordClose', operator)} />
								)}
							</div>
						</span>
						{accordion.isOpen && (
							<div
								dangerouslySetInnerHTML={{ __html: accordion.content }}
								className="accord-data font10"
							/>
						)}
					</div>
				))}
			</div>
		</div>
	);
};

/* istanbul ignore next */
function mapStateToProps(state) {
	return {
		themes: state.themes,
	};
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators({ ...actions }, dispatch),
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(ThemeElevenFaq);



// WEBPACK FOOTER //
// ./src/features/themes/ThemeEleven/pages/ThemeElevenFaq.js